import { FC } from 'react';
import { useCheckout } from '../../../../context/CheckoutContext';
import AddIcon from '@ordr-as/icons/AddIcon';
import EditIcon from '@ordr-as/icons/EditIcon';
import { useCartIsClosing } from '../../../../hooks/useCartIsBusy';
import { Button } from '@ordr-as/umami-react/button';
import { useLocation } from '../../../../context/LocationContext';
import { useActiveDigitalBill } from '../../../../context/DigitalBillStore';

const SelectOpenBillButton: FC = () => {
  const { setSidebarContent, tableNumber } = useCheckout();
  const activeDigitalBill = useActiveDigitalBill();
  const { isDigitalBillEnabled } = useLocation();

  const cartIsClosing = useCartIsClosing();

  const activeTableNumber = activeDigitalBill?.primaryReference || tableNumber;

  const handleClick = () => {
    if (cartIsClosing) {
      return;
    }

    if (!isDigitalBillEnabled) {
      setSidebarContent('SET_TABLE_NUMBER');
      return;
    }

    setSidebarContent('SELECT_TABLE');
  };

  return (
    <Button
      isDisabled={cartIsClosing}
      data-cy="select-table"
      className={'p-4 justify-self-center flex-shrink-0'}
      onClick={handleClick}
    >
      <div className="bg-purple-lightest rounded-full px-4 py-2">
        {activeTableNumber ? (
          <div className="text-brand-primary flex text-sm flex-row gap-1 items-center">
            <p className="text-sm font-bold">Table {activeTableNumber}</p>
            <EditIcon height={16} width={16} />
          </div>
        ) : (
          <div className="text-brand-primary flex text-sm flex-row gap-1 items-center">
            <AddIcon height={16} width={16} />
            <p className="text-sm font-bold">Select Table</p>
          </div>
        )}
      </div>
    </Button>
  );
};

export default SelectOpenBillButton;
